import { Header } from 'components/Header'
import { useIsScrollingDown } from 'hooks/useIsScrollingDown'
import React, { ComponentProps, useEffect, useRef, useState } from 'react'
import { MobileMenu } from '../MobileMenu'
import { MyAccountHeaderRoot } from './MyAccountHeader.style'

type MyAccountHeaderOwnProps = ComponentProps<typeof MyAccountHeaderRoot>
export type MyAccountHeaderProps = MyAccountHeaderOwnProps & {}

export const MyAccountHeader = (_props: MyAccountHeaderProps) => {
  const isScrollingDown = useIsScrollingDown()
  const [isOpen, setIsOpen] = useState(false)

  return (
    <MyAccountHeaderRoot isScrollingDown={isScrollingDown} isOpen={isOpen}>
      <Header />
      <MobileMenu isScrollingDown={isScrollingDown} setIsOpen={setIsOpen} isOpen={isOpen} />
    </MyAccountHeaderRoot>
  )
}
